import { render, staticRenderFns } from "./NoticeBoard.vue?vue&type=template&id=b3720b98&"
import script from "./NoticeBoard.vue?vue&type=script&lang=ts&"
export * from "./NoticeBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports